module.exports = __webpack_public_path__ + "img/app-store.7d591695.svg";